var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpeningQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9486 10.5118C14.9083 13.1505 11.2633 18.1444 10.868 22.1788C10.9998 22.1788 11.8781 22.048 12.5149 22.048C16.0501 22.048 18.5753 24.6867 18.5753 28.4485C18.5812 29.3236 18.4119 30.1911 18.0774 31.0007C17.7429 31.8103 17.2498 32.5458 16.6268 33.1646C16.0037 33.7834 15.2631 34.2731 14.4479 34.6053C13.6327 34.9375 12.7592 35.1056 11.8781 35.0998C7.70607 35.0998 4.05005 31.7087 4.05005 25.559C4.05005 17.9155 8.44167 10.8825 14.2825 6.75L18.9486 10.5118ZM39.1501 10.5118C35.1098 13.1505 31.5745 18.1444 31.0695 22.1788C31.2012 22.1788 32.0795 22.048 32.7163 22.048C33.5539 22.0362 34.3849 22.1957 35.1577 22.5167C35.9305 22.8376 36.6285 23.313 37.2083 23.9134C37.7881 24.5138 38.2373 25.2262 38.5279 26.0064C38.8185 26.7866 38.9443 27.6179 38.8975 28.4485C38.8801 30.228 38.1524 31.9279 36.8741 33.175C35.5957 34.422 33.8714 35.1143 32.0795 35.0998C27.9185 35.0998 24.2515 31.7196 24.2515 25.5699C24.2515 17.9373 28.6431 10.8934 34.484 6.7609L39.1501 10.5118Z",
    fill: "#E42436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeningQuotes);
export default __webpack_public_path__ + "static/media/opening-quotes.ae1fed2ffad059692be5babacd7f87a7.svg";
export { ForwardRef as ReactComponent };